define('responsive-gameday/controllers/PlayerCardViewController',['require','exports','module','GameDayCore','Responsive/controllers/CardViewController','datasource-manager/datasource-manager','message-service/message-service','GameDayCore/GDModel/enums/events/EventTypes','Responsive/util/renderComplete','Responsive/util/dom','responsive-gameday-tracking/responsive-gameday-tracking','../helpers/EventDistributor','gameday-resource-path/gameday-resource-path','gameday-device-interaction/gameday-device-interaction','jquery'],function (require, exports, module) {


    var GDC = require("GameDayCore"),
        CardViewController = require("Responsive/controllers/CardViewController"),
        DatasourceManager = require("datasource-manager/datasource-manager"),   
        MessageService = require("message-service/message-service"),
        EventTypes = require("GameDayCore/GDModel/enums/events/EventTypes"),
        renderComplete = require("Responsive/util/renderComplete"),
        dom = require("Responsive/util/dom"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        GDEventDistributor = require( '../helpers/EventDistributor' ),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        DeviceInteraction = require( "gameday-device-interaction/gameday-device-interaction" ),
        $ = require("jquery");

    var Superclass,
        SuperContainerclass,
        _noop = function () { },
        rSanitizeName = /[^a-zA-Z0-9-]/g,
        NATIVE_HOOK = !!(window.NATIVE && window.NATIVE.openWebView);
    // Add private methods here

    function messageProxy(that) {
        var ancha = document.createElement('a');
        return function (e) {
            var data = (e.data || e.originalEvent && e.originalEvent.data || '').split('cf:');
            if (data && data.length > 1) {
                ancha.href = '#player=' + data[1];
                that.cardListener.call(ancha, e);
            }
        }
    }

    function PlayerCardViewController(parent, dock) {
        var that = this;
        this.parentViewController = parent;
        this.window = null;
        this.config = {
            bounds  : '.responsive-app',
            selector: 'a[href^="#player="]',
            dock    : "right",
            usePageUrl : false
        };
        if(dock){
            if(typeof dock === "string"){
                this.config.dock=dock
            }else{
                $.extend(this.config,dock);
            }
        }
        that.messageProxy = messageProxy(this);
        this.cardListener = function (e) {
            var playerid = (this.hash || '').split('=')[1],
                deviceInteraction = DeviceInteraction.get();

            that.contentWrapper.innerHTML = '<div class="spinnerContainer"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>';

            e.stopImmediatePropagation();
            e.preventDefault();

            if (!playerid) { return false; }

            var frameUrl = DatasourceManager.get("playercardurl").getUrl({id:playerid}),
                pageUrl = resourcePath.get("internalPlayerCardLink",{pid : playerid});

            if (deviceInteraction.playercard({ title : "Player Card", url : pageUrl, pid : playerid })) {
                return false;
            }

            if(that.config.usePageUrl){
                window.location=pageUrl;
                return false;
            }
            if(that.isOpened){
                that.toggle();
                that.isOpened=false;
                that.closeCardListener();
                return that.cardListener.call(this,e);
            }
            var frame = $(that.opener);

            MessageService.publish(GDEventDistributor.prototype.events.OPEN_PLAYER_CARD);
            parent.presentFloatingModalViewController(that, that.fullscreen);
            that.isOpened = true;
            
            that.contentWrapper.appendChild(frame[0]);
            that.frame = frame;

            if (that.broadcastUpdate) {
                MessageService.removeListener(EventTypes.UPDATE, that.broadcastUpdate);
            }
            that.broadcastUpdate = function () {
                if (that.frame[0].contentWindow && that.frame[0].contentWindow.postMessage) {
                    that.frame[0].contentWindow.postMessage('refresh', location.protocol + '//' + location.host);
                }
            };
            renderComplete(function () {
                frame.attr('data', pageUrl)
                    .on('load error', function (e) {
                        
                        MessageService.addListener(EventTypes.UPDATE, that.broadcastUpdate);
                        frame.addClass('loaded');
                    }).attr('src', pageUrl)
                    .attr('type', 'text/html');
                
            });

            Tracking.track_playercard();
            return false;
        };

        this.closeCardListener = function (e) {
            if (that.isViewLoaded()) {
                that.contentWrapper.innerHTML = "";
                dom.removeNode(that.view, that.contentWrapper);
                // that.view.style='';
                that.viewDidDisappear();
                that.viewDidUnload();
                MessageService.removeListener(EventTypes.UPDATE, that.broadcastUpdate);
            }
            this.isOpened=false;
        };
        
        Superclass.constructor.call(this, {
            swipeToSpeed : 0.5,
            dockingSide : this.config.dock
        }, this.container, true);
        

        this.setClassName('PlayerCardViewController');
    }

    CardViewController.spawn(PlayerCardViewController).define({
        loadView: function () {
            Superclass.loadView.call(this);
            this.opener = '<iframe/>';
        },

        viewWillAppear: function () {
            Superclass.viewWillAppear.call(this);
            this.setClassName('PlayerCardViewController');
            MessageService.publish('viewStack::open', this);
        },

        on: function () {
            this.bounds = $(this.bounds || this.config.bounds);
            this.off(this.bounds);
            this.bounds.on('click touchstart', this.config.selector, this.cardListener);
            $(window).on('message', this.messageProxy);
        },

        off: function () {
            $(this.bounds || this.config.bounds).off('click', this.config.selector, this.cardListener);
            $(window).off('message', this.messageProxy);
        },

        viewWillDisappear: function () {
            this.closeCardListener();
            Superclass.viewWillDisappear.call(this);
            MessageService.publish('viewStack::close', this);

        },

        viewDidDisappear: function () {
            Superclass.viewDidDisappear.call(this);
        },

        viewDidUnload: function () {
            Superclass.viewDidUnload.call(this);
            this.view = null;
            this.childWrapper = null;
            this.frame = null;
        },

        setPlayerid: function (id) {
        },

        setCardType: function (type) {
        },

        setData: function (data) {
        }

    });

    PlayerCardViewController.supress = function () {
        PlayerCardViewController.isSuppressed = true;
        $('.responsive-root-view').on('click', 'a[href^="#player\="]', PlayerCardViewController.supressListener);
    };

    PlayerCardViewController.release = function () {
        PlayerCardViewController.isSuppressed = false;
        $('.responsive-root-view').off('click', 'a[href^="#player\="]', PlayerCardViewController.supressListener);
    };

    PlayerCardViewController.supressListener = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    };

    Superclass = PlayerCardViewController.superclass;
    return PlayerCardViewController;
});
